import type { CacheConfig } from '@/types/shared/caching.types'

export const BRANCH_CACHE_CONFIG: Record<string, CacheConfig> = {
  'org.branch-list': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000,
    backendTTL: 2 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['organization', 'branches'],
  },
  'org.branch-settings': {
    autosave: true,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000,
    backendTTL: 5 * 60 * 1000,
    storageType: 'sessionStorage',
    queryKey: ['organization', 'branch-settings'],
  },
  'academic.academic-years': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000, // 5 minutes
    backendTTL: 2 * 60 * 1000, // 2 minutes
    storageType: 'localStorage',
    queryKey: ['academic-years'],
  },
  'academic.terms': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000, // 5 minutes
    backendTTL: 2 * 60 * 1000, // 2 minutes
    storageType: 'localStorage',
    queryKey: ['terms'],
  },
  'academic.term-detail': {
    autosave: false,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000, // 10 minutes (single term detail)
    backendTTL: 5 * 60 * 1000, // 5 minutes
    storageType: 'localStorage',
    queryKey: ['term'],
  },
  'academic.classes': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000, // 5 minutes
    backendTTL: 2 * 60 * 1000, // 2 minutes
    storageType: 'localStorage',
    queryKey: ['classes'],
  },
  'academic.class-detail': {
    autosave: false,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000, // 10 minutes (single class detail)
    backendTTL: 5 * 60 * 1000, // 5 minutes
    storageType: 'localStorage',
    queryKey: ['class'],
  },
  'academic.sections': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000, // 5 minutes
    backendTTL: 2 * 60 * 1000, // 2 minutes
    storageType: 'localStorage',
    queryKey: ['sections'],
  },
  'academic.section-detail': {
    autosave: false,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000, // 10 minutes (single section detail)
    backendTTL: 5 * 60 * 1000, // 5 minutes
    storageType: 'localStorage',
    queryKey: ['section'],
  },
  'academic.class-sections': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000, // 5 minutes
    backendTTL: 2 * 60 * 1000, // 2 minutes
    storageType: 'localStorage',
    queryKey: ['class-sections'],
  },
  'academic.class-subjects': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000, // 5 minutes
    backendTTL: 2 * 60 * 1000, // 2 minutes
    storageType: 'localStorage',
    queryKey: ['class-subjects'],
  },
  'academic.subjects': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000, // 5 minutes
    backendTTL: 2 * 60 * 1000, // 2 minutes
    storageType: 'localStorage',
    queryKey: ['subjects'],
  },
  'academic.subject-detail': {
    autosave: false,
    apiCache: true,
    frontendTTL: 10 * 60 * 1000, // 10 minutes (single subject detail)
    backendTTL: 5 * 60 * 1000, // 5 minutes
    storageType: 'localStorage',
    queryKey: ['subject'],
  },
  'branch.roles': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000, // 5 minutes
    backendTTL: 2 * 60 * 1000, // 2 minutes
    storageType: 'localStorage',
    queryKey: ['branch-roles'],
  },
  'branch.groups': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000, // 5 minutes
    backendTTL: 2 * 60 * 1000, // 2 minutes
    storageType: 'localStorage',
    queryKey: ['branch-groups'],
  },
  'branch.formmanagement': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000, // 5 minutes
    backendTTL: 2 * 60 * 1000, // 2 minutes
    storageType: 'localStorage',
    queryKey: ['branch-forms'],
  },
  'branch.invitations': {
    autosave: false,
    apiCache: true,
    frontendTTL: 2 * 60 * 1000, // 2 minutes (invitations change frequently)
    backendTTL: 1 * 60 * 1000, // 1 minute
    storageType: 'localStorage',
    queryKey: ['invitations'],
  },
  'branch.onboardings': {
    autosave: false,
    apiCache: true,
    frontendTTL: 2 * 60 * 1000, // 2 minutes
    backendTTL: 1 * 60 * 1000, // 1 minute
    storageType: 'localStorage',
    queryKey: ['onboardings'],
  },
  'branch.students': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000, // 5 minutes
    backendTTL: 2 * 60 * 1000, // 2 minutes
    storageType: 'localStorage',
    queryKey: ['students'],
  },
  'branch.employeemanagement': {
    autosave: false,
    apiCache: true,
    frontendTTL: 2 * 60 * 1000, // 2 min — reuse prefetched data on hover
    backendTTL: 2 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['employees'],
  },
  'branch.departments': {
    autosave: false,
    apiCache: true,
    frontendTTL: 5 * 60 * 1000,
    backendTTL: 2 * 60 * 1000,
    storageType: 'localStorage',
    queryKey: ['departments'],
  },
}
